module.exports = __webpack_public_path__ + "img/icon-warning-jordskred-3.43f667cd.svg";